import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "section-selector-wrapper" };
const _hoisted_2 = { class: "nav-item" };
const _hoisted_3 = { class: "section-selector-content" };
const _hoisted_4 = { class: "section-selector-text" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SectionSelectorModal = _resolveComponent("SectionSelectorModal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
                class: "btn btn-soft-primary section-selector-btn w-100",
                type: "button",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => ($setup.openModal && $setup.openModal(...args)))
            }, [
                _createElementVNode("span", _hoisted_3, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "section-selector-icon" }, [
                        _createElementVNode("i", { class: "ri-building-line" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_4, _toDisplayString($setup.selectedBranchName), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-arrow-down-s-line section-selector-arrow" }, null, -1))
                ])
            ])
        ]),
        _createVNode(_component_SectionSelectorModal, {
            businesses: $setup.businesses,
            onItemSelected: $setup.handleItemSelected
        }, null, 8, ["businesses", "onItemSelected"])
    ]));
}
